import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { DocumentDownloadService } from '@xengage/gw-portals-document-js';

export default class AccountBillingDetailsService {
    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPolicyBillingSummary', [policyNumber], additionalHeaders);
    }

    static retrievePaymentTransactionsForAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'retrievePaymentTransactionsForAccount', [accountNumber], additionalHeaders);
    }

    static getSelectedAccountBillingSummary_Ext(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'getSelectedAccountBillingSummary_Ext', [accountNumber], additionalHeaders);
    }

    static createTransactionReportForAccount(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'createTransactionReportForAccount', [accountNumber], additionalHeaders);
    }

    static createTransactionReportForPolicy(accountNumber,policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'createTransactionReportForPolicy', [accountNumber,policyNumber], additionalHeaders);
    }

    static getCommissionDocumentsForProducerCode(data,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'getCommissionDocumentsForProducerCode', [data], additionalHeaders);
    }

    static getDocumentsForPolicyBySearch(policyNumber, idNumber,additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'getDocumentsForPolicyBySearch', [policyNumber, idNumber], additionalHeaders);
    }

    static getProducerStatements(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'getProducerStatements', [data], additionalHeaders);
    }

    static getCommissionStatementAsExcel(data,additionalHeaders={}){
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'getCommissionStatementAsExcel', [data], additionalHeaders);
    }

    static downloadbillingDocument(documentID, token) {
        return DocumentDownloadService.getDocumentLink(getProxiedServiceUrl('billingDocument'), documentID, token);
    }

    static getPolicyBillingSummaryWithOds_ext(data,additionalHeaders={}){
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'getPolicyBillingSummaryWithOds_ext', [data], additionalHeaders);
    }
    
}
